import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(
  () => import("../../components/settings/corporateDiscountRate/main")
);

const CorporateDiscountRate = () => {
  return (
    <Suspense fallback={<CircularLoader />}>
      <Main />
    </Suspense>
  );
};

export default CorporateDiscountRate;
